// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".back[data-v-0fab7133]{margin-bottom:45px}@media(max-width:960px){.back[data-v-0fab7133]{margin-top:30px;margin-bottom:10px}}.back[data-v-0fab7133]:hover{background-color:var(--q4s-neutral-250);box-shadow:0 2px 3px rgba(var(--q4s-accent-rgb),.07),0 10px 24px -12px rgba(var(--q4s-accent-rgb),.24)}", ""]);
// Exports
module.exports = exports;
